
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "@environment/environment";
import { Users } from "../admin/Model/admin";
import { GetEnvVarService } from "./get-env-var.service";

@Injectable()
export class AuthService {
  private authUrl: string;
  private access_token: string;
  private baseUrl: string;

  constructor(@Inject(HttpClient) private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }

   getToken(authorization_code:string){
//     //this.http.post(this.url+'Oauth/Token',);
      debugger;
          return this.http.get(this.baseUrl + `/api/token/` + authorization_code).pipe(
          map(response => response),
           catchError(handleError),);
   
 }
  
//  getToken(authorization_code:string){

//        debugger;
//          return this.http.get(this.baseUrl + `/api/userdetail`)
//            .map(response => response.json())
//             .catch(handleError);
     
//    }

  // getUserDetails(token:string){

  getUserDetails(token:string) {
    debugger;
    let headers = new Headers();
    headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers.set('token', token);
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
        "token": token
      })
    };
    return this.http
      .get(environment.stage.idmurl + "userdetail", httpOptions).pipe(
      map((response) => response));
  }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}
